var tasilValidate = {
	input: {
		eventHandlerClass: "input__label",
		className: "input",
		correctClass: "correct",
		eye: $(".input-password-eye"),
		strong: $(".input-password-strong"),
	},

	validate: function (form) {
		var fields = [],
			fieldsTypes = [];

		function validateForm() {
			if ($("." + form).length > 0) {
				return $("." + form);
			} else {
				return false;
			}
		}

		function fieldsToValidate() {
			$.each($(validateForm()).find("input"), function (index, item) {
				if (item.getAttribute("data-validate-type")) {
					fields.push(item);
					fieldsTypes.push(item.getAttribute("data-validate-type"));
				}
			});
		}

		var methods = {
			isNotEmpty: function (value) {
				return value.length > 0;
			},
			isMinLength: function (value, min) {
				return value.length >= min;
			},
			isMaxLength: function (value, max) {
				return value.length <= max;
			},
			areSame: function (value1, value2) {
				return value1 == value2;
			},
			isMail: function (value) {
				var template = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return template.test(value);
			},
			isPhone: function (value) {
				//var template = /([a-z])|([A-Z])|([!@#$%^&*\-\=~`\[\{\]\}\|\\\:\;\"\'\,\.\/\<\>\?])/g;
				return value.length == 11 || value.length == 12;
			},
			hasNoNumbers: function (value) {
				var template = /([0-9])/g;

				return !template.test(value);
			},
			hasNoSpecialChars: function (value) {
				var template = /([!@#$%^&*\-\=~`\[\{\]\}\|\\\:\;\"\'\,\.\/\<\>\?])/g;

				return !template.test(value);
			},
			hasCapitalLetter: function (value) {
				var template = /([A-Z])/;
				return template.test(value);
			},
		};

		var rules = {
			name: function (value) {
				var out =
					methods.isNotEmpty(value) &&
					methods.isMinLength(value, 2) &&
					methods.isMaxLength(value, 64) &&
					methods.hasNoNumbers(value) &&
					methods.hasNoSpecialChars(value);
				return out;
			},
			companyName: function (value) {
				return methods.isNotEmpty(value);
			},
			industry: function (value) {
				return methods.isNotEmpty(value);
			},
			description: function (value) {
				return methods.isNotEmpty(value) && methods.isMaxLength(value, 1024);
			},
			mail: function (value) {
				var out = methods.isNotEmpty(value) && methods.isMail(value);
				return out;
			},
			phone: function (value) {
				var out = methods.isNotEmpty(value) && methods.isPhone(value);
				return out;
			},
			password: function (value) {
				var out =
					methods.isNotEmpty(value) &&
					methods.isMinLength(value, 8) &&
					methods.isMaxLength(value, 30) &&
					methods.hasCapitalLetter(value);
				return out;
			},
			password2: function (value) {
				var out =
					rules.password(value) &&
					methods.areSame(value, $('[data-validate-type="password"]').val());
				return out;
			},
			password3: function (value) {
				var out = rules.password(value);
				return out;
			},
			password4: function (value) {
				var out =
					rules.password(value) &&
					methods.areSame(value, $('[data-validate-type="password3"]').val());
				return out;
			},
			login: function (value) {
				var out =
					methods.isNotEmpty(value) &&
					methods.isMinLength(value, 6) &&
					methods.isMaxLength(value, 64);
				return out;
			},
		};

		function startValidate() {
			var isValid = true;
			var hasErrors = false;
			var itemsErrorMessagesContainer = $("." + form).find(".validate-messages");
			$.each(fields, function (index, item) {
				try {
					var status = rules[fieldsTypes[index]](item.value);
					var itemsErrorMessage = $("." + form).find(
						".validate-messages__" + fieldsTypes[index]
					);
					if (!status) {
						if ($(item).val().length > 0) {
							$(item).addClass("error");
							$(item).removeClass("correct");
							itemsErrorMessage.addClass("show");
							hasErrors = true;
						}
						isValid = false;
					} else {
						$(item).removeClass("error");
						$(item).addClass("correct");
						itemsErrorMessage.removeClass("show");
					}
				} catch (e) {
					console.log(e);
				}
				var submitBtn = $("." + form).find("#register-button");
				if (form === "validate--register" && isValid) {
					submitBtn.attr("disabled", false);
					submitBtn.removeClass("button--inactive");
				} else {
					submitBtn.attr("disabled", true);
					submitBtn.addClass("button--inactive");
				}
			});

			hasErrors
				? itemsErrorMessagesContainer.addClass("show")
				: itemsErrorMessagesContainer.removeClass("show");
			return isValid;
		}

		function addListener() {
			$("." + form)
				.find(".input, .input-password")
				.on("focus keypress keyup change", function () {
					var itemsErrorMessage = $("." + form).find(
						".validate-messages__" + $(this).attr("data-validate-type")
					);
					if ($(this).val() != "") {
						$(this).addClass("touched");
							//startValidate();
					} else {
						$(this).removeClass(tasilValidate.input.correctClass);
						$(this).removeClass("error");
						$(this).removeClass("touched");
						itemsErrorMessage.removeClass("show");
					}
				});
		}

		(function () {
			if (validateForm().length > 0) {
				fieldsToValidate();
				addListener();
			}
			// $("." + form)
			// 	.find('[type="submit"]')
			// 	.on("click", function (event) {
			// 		event.preventDefault();

			// 		if (startValidate()) {
			// 			$("." + form).submit();
			// 		}
			// 	});
		})();

		//return startValidate();
	},

	forgotPassword: {
		view: $(".forgot-password"),
		closeButton: $(".forgot-password__close"),
		openButton: $(".input-link--forgot"),
		open: function () {
			this.view.show();
		},
		close: function () {
			this.view.hide();
		},
		openListener: function () {
			$(tasilValidate.forgotPassword.openButton).on("click", function (event) {
				event.preventDefault();
				tasilValidate.forgotPassword.open();
			});
		},
		closeListener: function () {
			$(tasilValidate.forgotPassword.closeButton).on("click", function () {
				tasilValidate.forgotPassword.close();
			});
		},
		init: function () {
			this.closeListener();
			this.openListener();
			tasilValidate.validate("forgot-password");
		},
	},
};

$(document).ready(function () {
	// forms classes for checking validation
	tasilValidate.validate("validate--register");
	tasilValidate.validate("validate--login");
	tasilValidate.validate("validate--confirm");
	//tasilValidate.validate("validate--reset");
	tasilValidate.validate("validate--footer");
	tasilValidate.validate("validate--tasil-plus");
	tasilValidate.validate("validate--opt-out");

	//tasilValidate.forgotPassword.init();

	// fixed bug of not recognizing focus on firefox
	/*	$("input").focus(function(event){
		setTimeout(function() {
			$(event.target).closest('input').blur()
		}, 1);
	});*/

	$(document).on("click", function (event) {
		var target = event.target;

		if ($(target).hasClass(tasilValidate.input.eventHandlerClass)) {
			var labelIsFor = target.getAttribute("for");
			$('[name="' + labelIsFor + '"]').focus();
		}
	});

	$(tasilValidate.input.strong).on("click", function () {
		$(this).addClass("user-click");
	});

	$(tasilValidate.input.className).on(
		"keypress keyup change focus",
		function () {
			if (
				$(this).attr("name") == "password" ||
				$(this).attr("name") == "newPassword"
			) {
				tasilValidate.input.strong.removeClass(
					"level-0 level-1 level-2 level-3 level-4 user-click"
				);
				var userPassword = $(this).val();
				var minPasswordLength = 8,
					maxPasswordLength = 30,
					maxPasswordStrengthPointsOfLength = 3;

				var passwordLengthPoints = Math.floor(
					(userPassword.length / minPasswordLength) *
						maxPasswordStrengthPointsOfLength
				);
				passwordLengthPoints =
					passwordLengthPoints <= maxPasswordStrengthPointsOfLength
						? passwordLengthPoints
						: maxPasswordStrengthPointsOfLength;
				var hasCapitalPoints = 0;
				var isNotEmpty = !!userPassword.length;

				/[A-Z]/.test(userPassword)
					? (hasCapitalPoints = 1)
					: (hasCapitalPoints = 0);

				var passwordLevelTotalPoints = passwordLengthPoints + hasCapitalPoints;
				tasilValidate.input.strong.addClass(
					"level-" + passwordLevelTotalPoints
				);
				isNotEmpty
					? tasilValidate.input.strong.addClass("not-empty")
					: tasilValidate.input.strong.removeClass("not-empty");
			}
		}
	);

	// tasilValidate.input.eye.on("click", function () {
	// 	$(this).toggleClass("close");
	// 	$(this).siblings(".input-password").attr("type") == "text"
	// 		? $(this).siblings(".input-password").attr("type", "password")
	// 		: $(this).siblings(".input-password").attr("type", "text");
	// });
});
